import styled from 'styled-components';

export const StyledScrollPointerCharacter = styled.span`
  position: absolute;
  height: ${({ radius }) => radius}px;
  left: 0;
  top: 0;
  width: 0;
  font-weight: 700;
  transform-origin: bottom center;
  transform: rotate(${({ rotation }) => rotation}deg);
`;

